import React, { useState, useEffect } from 'react';

export const OffCanvas = ({ show, onClose, title, children }) => {
    const [isLoading, setIsLoading] = useState(true);

    // Reset loader state when offcanvas is closed and reopened
    useEffect(() => {
        if (show) {
            setIsLoading(true);
        }
    }, [show]);

    // Clone the iframe and attach an onLoad handler
    const enhancedChildren = React.Children.map(children, child => {
        if (child.type === 'iframe') {
            return React.cloneElement(child, {
                onLoad: () => setIsLoading(false)
            });
        }
        return child;
    });

    return (
        <div
            className={`offcanvas offcanvas-end ${show ? 'show' : ''}`}
            tabIndex="-1"
            id="offcanvasRight"
            aria-labelledby="offcanvasRightLabel"
            style={{ visibility: show ? 'visible' : 'hidden' }}
        >
            <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasRightLabel">{title}</h5>
                <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
            </div>

            <div className="offcanvas-body p-0 m-0 position-relative" style={{ height: '90vh' }}>
                {isLoading && (
                    <div className="position-absolute top-50 start-50 translate-middle">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
                {enhancedChildren}
            </div>
        </div>
    );
};
